(() => {
  if (customElements.get('send-gift-fields')) {
    return;
  }

  class SendGiftFields extends HTMLElement {
    static ACTIVE_CLASS = 'is-open';

    constructor() {
      super();

      this.onSummaryClick = this.onSummaryClick.bind(this);
      this.onUpdateField = this.onUpdateField.bind(this);
      this.onClearBtnClick = this.onClearBtnClick.bind(this);
    }

    connectedCallback() {
      this.init();
      this.attachEvents();
    }

    disconnectedCallback() {
      this.detachEvents();
    }

    attachEvents() {
      this.debouncedInput = this.debounce(this.onUpdateField, 1000);

      this.summaryElement?.addEventListener('click', this.onSummaryClick);

      this.fields.forEach((field) => {
        field.addEventListener('input', this.debouncedInput);
      });

      this.clearBtn?.addEventListener('click', this.onClearBtnClick);
    }

    detachEvents() {
      this.summaryElement?.removeEventListener('click', this.onSummaryClick);

      this.fields.forEach((field) => {
        field.removeEventListener('input', this.debouncedInput);
      });

      this.clearBtn?.removeEventListener('click', this.onClearBtnClick);
    }

    init() {
      this.detailsElement = this.querySelector('details');
      this.summaryElement = this.detailsElement?.querySelector('summary');
      this.titleText = this.summaryElement?.querySelector('[data-title]');
      this.fields = this.querySelectorAll('[data-field]');
      this.clearBtn = this.querySelector('[data-clear-btn]');
    }

    onSummaryClick(event) {
      const isOpen = this.detailsElement.hasAttribute('open');

      event.preventDefault();

      isOpen
        ? this.close()
        : this.open();
    }

    open() {
      setTimeout(() => {
        this.detailsElement.classList.add(SendGiftFields.ACTIVE_CLASS);
      });

      this.detailsElement.open = true;

      this.summaryElement.setAttribute('aria-expanded', true);
    }

    close() {
      this.detailsElement.classList.remove(SendGiftFields.ACTIVE_CLASS);

      this.summaryElement.setAttribute('aria-expanded', false);

      this.closeAnimation();
    }

    closeAnimation() {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          this.detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }

    onUpdateField() {
      const allFieldsFilled = Array.from(this.fields).every((field) => field.value.trim() !== '');
      const formData = new FormData();

      this.fields.forEach(field => {
        const attributeName = field.getAttribute('name');
        const value = allFieldsFilled ? field.value : '';

        formData.append(attributeName, value);
      });

      formData.append('attributes[Send as Gift]', allFieldsFilled ? 'Yes' : '');

      if (this.titleText) {
        this.titleText.textContent = allFieldsFilled ? window.theme.strings.cart.edit_send_as_gift : window.theme.strings.cart.send_as_gift;
      }

      this.updateCartAttributes(formData);
    }

    onClearBtnClick() {
      this.fields.forEach(field => {
        field.value = ''

        field.dispatchEvent(new Event('input', { bubbles: true }));
      });

      this.summaryElement.click();
    }

    updateCartAttributes(data) {
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: data,
      })
        .then(res => res.json())
        .catch(err => console.error(err));
    }

    debounce = (fn, wait) => {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    };
  }

  customElements.define('send-gift-fields', SendGiftFields);
})();

